import { render, staticRenderFns } from "./GroupDataTable.vue?vue&type=template&id=5692b4f8&scoped=true&"
import script from "./GroupDataTable.vue?vue&type=script&lang=js&"
export * from "./GroupDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupDataTable.vue?vue&type=style&index=0&id=5692b4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5692b4f8",
  null
  
)

export default component.exports